import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Point } from '../types/point';

interface WorldState {
  points: Point[];
  viewport: { x: number; y: number; zoom: number };
  area: { x_min: number; y_min: number; x_max: number; y_max: number };
}

const initialState: WorldState = {
  points: [],
  viewport: { x: 0, y: 0, zoom: 1 },
  area: { x_min: -100, y_min: -100, x_max: 100, y_max: 100 },
};

const worldSlice = createSlice({
  name: 'world',
  initialState,
  reducers: {
    setPoints: (state, action: PayloadAction<Point[]>) => {
      state.points = action.payload;
    },
    updatePoints: (state, action: PayloadAction<Point[]>) => {
      // заменяем или добавляем? для простоты заменим всё
      state.points = action.payload;
    },
    setViewport: (state, action: PayloadAction<Partial<WorldState['viewport']>>) => {
      state.viewport = { ...state.viewport, ...action.payload };
    },
    setArea: (state, action: PayloadAction<WorldState['area']>) => {
      state.area = action.payload;
    },
  },
});

export const { setPoints, updatePoints, setViewport, setArea } = worldSlice.actions;
export default worldSlice.reducer;